import { PendingDocumentMove } from "../../../api/ClientFileApi";

export const OwnClaimsMaxLength = {
  debtorName: 50,
  debtorAddress: 50,
  relationship: 25,
  legalReason: 255,
  text: 4000,
} as const;

export interface OwnClaimFormValue {
  key: string;
  id: string | null;
  debtorName: string | null;
  debtorAddress: string | null;
  isRelated: boolean | null;
  relationship: string | null;
  legalReason: string | null;
  amount: number | null;
  dueDate: Date | null;
  isSecured: boolean | null;
  securities: string | null;
  isDisputed: boolean | null;
  hasPendingCourtProceedings: boolean | null;
  disputeDetails: string | null;
  isCollectible: boolean | null;
  collectionSteps: string | null;
}

export type OwnClaimField = Exclude<keyof OwnClaimFormValue, "key" | "id">;

export interface AssetOwnClaimsFormValues {
  hasOwnClaims: boolean | null;
  ownClaims: OwnClaimFormValue[];
  ownClaimDocuments: File[];
  documentMoves: PendingDocumentMove[];
}
